import { render, staticRenderFns } from "./ShowClients.vue?vue&type=template&id=4addabe4&scoped=true"
import script from "./ShowClients.vue?vue&type=script&lang=js"
export * from "./ShowClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4addabe4",
  null
  
)

export default component.exports